export interface IconProps {
  size?: number;
  className?: string;
}

export const CloseIcon = ({ size = 20, className = '' }: IconProps) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox='0 0 24 24'
      fill='none'
      stroke='currentColor'
      strokeWidth='2'
      strokeLinecap='round'
      strokeLinejoin='round'
      className={className}
      xmlns='http://www.w3.org/2000/svg'
    >
      <path d='M6 18L18 6M6 6l12 12' />
    </svg>
  );
};
